<template>
  <el-dialog
    :title="$t('user_profile.your_organizations.modals.title', {name: organizationName})"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-press-escape=true
    custom-class="elsa-modal"
    :center=false
    width="255"
    top="100px"
    v-on:closed="closed"
    v-on:open="confirmed=false"
  >
    <api-errors :errors="errors" />

    <slot v-if="organizationOnlyAdmin">
      <h2>
        <slot v-if="confirmed">
          {{$t('user_profile.your_organizations.modals.admin.message_2', { name: organizationName })}}
        </slot>
        <slot v-else>
          {{$t('user_profile.your_organizations.modals.admin.message_1', { name: organizationName })}}
        </slot>
      </h2>
      <span slot="footer" class="dialog-footer">
        <slot v-if="confirmed">
          <primary-button @click.native="handleClose">
            {{$t('user_profile.your_organizations.modals.got_it')}}
          </primary-button>
        </slot>
        <slot v-else>
          <primary-button class="confirm-withdraw" @click.native="handleConfirmWithdraw">
          {{$t('user_profile.your_organizations.modals.confirm')}}
        </primary-button>
        <tertiary-button @click.native="handleClose">
          {{$t('user_profile.your_organizations.modals.cancel')}}
        </tertiary-button>
        </slot>
      </span>
    </slot>

    <slot v-else-if="organizationIsTeacher">
      <h2>
        <slot v-if="confirmed">
          {{$t('user_profile.your_organizations.modals.teacher.message_2', { name: organizationName, numberOfClasses: 3})}}
        </slot>
        <slot v-else>
          {{$t('user_profile.your_organizations.modals.teacher.message_1', { name: organizationName })}}
        </slot>
      </h2>
      <span slot="footer" class="dialog-footer">
        <slot v-if="confirmed">
          <primary-button @click.native="handleClose">
            {{$t('user_profile.your_organizations.modals.got_it')}}
          </primary-button>
        </slot>
        <slot v-else>
          <primary-button class="confirm-withdraw" @click.native="handleConfirmWithdraw">
          {{$t('user_profile.your_organizations.modals.confirm')}}
        </primary-button>
        <tertiary-button @click.native="handleClose">
          {{$t('user_profile.your_organizations.modals.cancel')}}
        </tertiary-button>
        </slot>
      </span>
    </slot>

    <slot v-else>
      <h2>
        <slot v-if="confirmed">
          {{$t('user_profile.your_organizations.modals.student.message_2', { name: organizationName })}}
        </slot>
        <slot v-else>
          {{$t('user_profile.your_organizations.modals.student.message_1', { name: organizationName })}}
        </slot>
      </h2>
      <span slot="footer" class="dialog-footer">
        <primary-button class="confirm-withdraw" @click.native="handleConfirmWithdraw">
          {{$t('user_profile.your_organizations.modals.confirm')}}
        </primary-button>
        <tertiary-button @click.native="handleClose">
          {{$t('user_profile.your_organizations.modals.cancel')}}
        </tertiary-button>
      </span>
    </slot>
  </el-dialog>
</template>

<script>
  import ApiErrors from '@/components/common/ApiErrors'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import {
    find, reject, propEq, compose, isEmpty, defaultTo, propOr, includes
  } from 'ramda'

  export default {
    name: "WithdrawFromOrganization",
    props: [
      "dialogVisible",
      "organizationId",
      "organizationName",
      "organizationIsOwner",
      "organizationData",
      'userId',
    ],
    components: {
      PrimaryButton,
      TertiaryButton,
      ApiErrors,
    },
    data() {
      return {
        confirmed: false,
        errors: [],
      }
    },
    methods: {
      handleConfirmWithdraw(){
        if(this.confirmed){
          const organizationId = this.organizationId;
          return this.$store.dispatch('organization/removeFromOrganization', {
            userId: this.$store.state.user.userInfo.id,
            organizationId
          })
          .then(() => this.$store.dispatch('organization/loadUserOrganizationsData'))
          .then(() => this.$emit('closed'))
        }

        this.confirmed = true;

      },
      handleCancelClick () { this.$emit("closed") },
      handleClose () { this.$emit("closed") },
      closed () {
      }
    },
    computed: {
      organizationOnlyAdmin() {
        const organizationAdmins = this.$store.getters['organization/withdrawOrganizationAdmins']
        const userId = this.$store.getters['user/getUserId']

        const result =  compose(
          isEmpty,
          reject(propEq('id', userId)),
          defaultTo([])
        )(organizationAdmins)

        return result;
      },
      organizationIsTeacher() {
        const isTeacher = compose(
          includes('teacher'),
          propOr([], 'roles'),
          find(propEq('organizationId', this.organizationId))
        )(this.$store.getters['organization/userOrganizationsData'])

        return isTeacher
      }
    },
    watch: {
      dialogVisible: {
        immediate: true,
        deep: true,
        handler(visible) {
          if(visible) {
            this.$store.dispatch('organization/getWithdrawOrganizationAdmins', {
              organizationId: this.organizationId,
            })
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
@import "../../../scss/colors";

.el-dialog.elsa-modal h2::v-deep {
  font-weight: 500;
  font-size: 18px;
  color: $dark-blue-2;
  line-height: 28px;
}

.elsa-button.confirm-withdraw, .elsa-button.confirm-withdraw:hover {
  background: $orange;
  border-radius: 40px;
}

</style>
